import { isUndefined } from "lodash";

export const isTouchDevice = () => {
  return !isUndefined(window.ontouchstart);
};
